import { queryKeys } from "../queryKeys";
import { type GetActivitiesParams, getActivities } from "../rest/account";
import { useRequest } from ".";

export const useGetActivities = (
  { accountID, paper, activityTypes, after, date, until }: GetActivitiesParams,
  options = {},
) => {
  const { data, ...rest } = useRequest(
    queryKeys.activities.list(
      accountID,
      paper,
      activityTypes?.join(","),
      after,
      date,
      until,
    ),
    () =>
      getActivities({
        accountID: accountID || "",
        paper,
        activityTypes,
        after,
        date,
        until,
      }),
    {
      ...options,
      // Suppress the shared error toast for this query (duplicate error handling).
      meta: { showErrorToast: false },
    },
  );

  return { activities: data || [], ...rest };
};

export default useGetActivities;
